// import axios from 'axios';

// const BASE_URL = 'https://backend-app-peluqueria.vercel.app';
// //const BASE_URL ='https://peluqueriapichichu.onrender.com'
// export const axiosInstance=axios.create({
//     baseURL: BASE_URL
// });

// export const axiosPrivate = axios.create({
//     baseURL: BASE_URL,
//     headers: { 'Content-Type': 'application/json' },
//     withCredentials: true
// });

// const host={
//     //development:"https://peluqueriapichichu.onrender.com"
//     development:BASE_URL
// }

// export default host

const rutaBackend="https://backend-app-peluqueria.vercel.app"
//const rutaBacken="backend-app-peluqueria-ns26xe7p8-walcruz198821s-projects.vercel.app"
//const rutaBackend="http://localhost:3002"


export default rutaBackend
